var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"header-logo",attrs:{"to":_vm.localePath('/')}},[_c('nuxt-img',{attrs:{"src":_vm.logoSrc,"alt":_vm.logoAlt,"title":_vm.logoAlt,"width":_vm.logoWidth,"height":_vm.logoHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }